import React, { useMemo } from 'react';

import {
  ContainerProgressButton,
  ButtonProgressBar,
  ButtomProgressText
} from "./styles";

export default function ProgressButton({
    value,
    total,
    text
}) {
  const progress = useMemo(() => {
    return (value / total) * 100
  }, [value, total])

  return(
    <ContainerProgressButton>
        <ButtonProgressBar style={{ width: `${progress}%` }}/>
        <ButtomProgressText>{text} {value} / {total}</ButtomProgressText>
    </ContainerProgressButton>
  );
}
